import { render, staticRenderFns } from "./addDistributionPromoter.vue?vue&type=template&id=f70c18dc&scoped=true&"
import script from "./addDistributionPromoter.vue?vue&type=script&lang=js&"
export * from "./addDistributionPromoter.vue?vue&type=script&lang=js&"
import style0 from "./addDistributionPromoter.vue?vue&type=style&index=0&id=f70c18dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c18dc",
  null
  
)

export default component.exports